import { User } from '@monorepo/types';

/**
 * User Utility Constants
 */
export const USER_CONSTANTS = {
  /** Time window (in milliseconds) to consider a user as "new" */
  NEW_USER_WINDOW_MS: 60 * 1000, // 60 seconds
} as const;

/**
 * Determines if a user account was created within the "new user" window
 * Used to determine if we should set $set_once attribution properties in Mixpanel
 *
 * @param user - The user object with createdAt timestamp
 * @returns true if account age is less than NEW_USER_WINDOW_MS
 *
 * @example
 * const user = { createdAt: new Date(Date.now() - 30000).toISOString() };
 * isNewUser(user) // => true (created 30 seconds ago)
 *
 * const oldUser = { createdAt: new Date(Date.now() - 120000).toISOString() };
 * isNewUser(oldUser) // => false (created 2 minutes ago)
 */
export const isNewUser = (user: User): boolean => {
  if (!user.createdAt) return false;

  const accountAge = Date.now() - new Date(user.createdAt).getTime();

  return accountAge < USER_CONSTANTS.NEW_USER_WINDOW_MS;
};
